<div class="border border-grey-lighter rounded-xl p-4">
	<app-create-company-side-form
		label="Add brokerage"
		[minify]="true"
		(onSubmit)="onSubmit($event)"
		(onCancel)="_onCancel()"
		[name]="name"
		[company]="brokerage"
	>
	</app-create-company-side-form>
</div>
